import { createSignal, useContext } from 'solid-js';
import { AppContext } from '../../../../app-context-provider/app-context-provider';
import { setCookie } from '../../../../tools/cookie-helpers';
import { Button } from '../../../../ui-components/button/button';
import { Heading } from '../../../../ui-components/heading/heading';
import { Modal } from '../../../../ui-components/modal/modal';
import { Text } from '../../../../ui-components/text/text';
import { StyledPdfModalText, StyledButtonWrapper } from './pdf-newsletter-signup-prompt.style';
import { StyledVerticalSpace } from '../../../../ui-components/utility-style-components/spacing';
import { useNavigate } from '@solidjs/router';
import { showNewsletterPrompt } from './newsletter-prompt-checker';
import { gql } from 'graphql-request';

export const GET_PDF_MODAL_SETTINGS_QUERY = gql`
    query {
        settings: resource(externalId: "announcement-settings") {
            content
        }
    }
`;

export const NewsletterSignupPromptForPdf = () => {
    const { localize, createCachedResource } = useContext(AppContext);
    const [ dismissed, setDismissed ] = createSignal(false);
    const navigate = useNavigate();

    const [ modalSettings ] = createCachedResource(GET_PDF_MODAL_SETTINGS_QUERY, {}, true);

    const data = () => modalSettings()?.settings?.content?.pdfModal;

    const showModal = () => {
        if (!modalSettings() || !data()?.enabled) {
            return false;
        }

        if (!data()?.ctaLink) {
            return false;
        }

        if (dismissed()) return false;

        return showNewsletterPrompt();
    };

    const dismissNewsletterPrompt = () => {
        setCookie('dismissed-pdf-builder-newsletter-prompt', 'true');
        setDismissed(true);
    };

    return (
        <Modal visible={showModal()} onClose={() => dismissNewsletterPrompt()} darkenBackground={true} size='small'>
            <Heading tag="h1" variant="medium">{data()?.title}</Heading>
            <StyledVerticalSpace size={1} />
            <Text fontSize='normal'>{data()?.body}</Text>
            <StyledVerticalSpace size={1} />
            <StyledPdfModalText>
                <StyledButtonWrapper>
                    <Button
                        label={data()?.closeButtonText || localize('close', 'Close')}
                        onClick={() => dismissNewsletterPrompt()}
                        variant='secondary'
                    />
                </StyledButtonWrapper>
                <StyledButtonWrapper>
                    <Button
                        label={data()?.ctaLink?.title}
                        onClick={() => {
                            dismissNewsletterPrompt();
                            navigate(data()?.ctaLink?.url);
                        }}
                    />
                </StyledButtonWrapper>
            </StyledPdfModalText>
        </Modal>
    );
};